import { WEEK_DAY_GROUP } from "@/components/calendar";
import { useNewPriceValue } from "@/shared/client";
import { MEDIA } from "@/styles/common";
import { createDate } from "@/utils";
import { Center } from "@chakra-ui/react";
import dayjs from "dayjs";
import { useHandlePrice } from "../../hooks";
import { CustomButton, CustomText } from "./dateHandler.style";

export const DateHandler = ({ roomIdx, durationDate }: { roomIdx: string; durationDate: string }) => {
    const { mutate } = useHandlePrice();
    const { currentDateInfo, currentWeekdayNumber, currentObj } = createDate();
    const newDate = {
        year: currentDateInfo.split("-")[0],
        month: currentDateInfo.split("-")[1],
        days: currentDateInfo.split("-")[2],
        weekday: WEEK_DAY_GROUP.find((week) => week.weekNum === currentWeekdayNumber)?.weekDay,
    };

    const startDuration = durationDate.split("~")[0];
    const endDuration = durationDate.split("~")[1];
    const newPriceData = useNewPriceValue();

    const handlePriceData = (action: string) => {
        if (newPriceData) {
            const newDurationDate = newPriceData.durationDate;
            const newStartDuration = newDurationDate.split("~")[0];
            const newEndDuration = newDurationDate.split("~")[1];

            mutate({ section: "prices", date: action === "prev" ? newStartDuration : newEndDuration, roomIdx, action });
        }

        if (!newPriceData) {
            mutate({ section: "prices", date: action === "prev" ? startDuration : endDuration, roomIdx, action });
        }
    };

    const { isMobile } = MEDIA();

    return (
        <Center columnGap={isMobile ? "16px" : "48px"}>
            <CustomButton
                size="medium"
                onClick={() => {
                    if (newPriceData) {
                        const { durationDate } = newPriceData;
                        const newStartDuration = durationDate.split("~")[0];
                        const isCurrentDateValid = dayjs(newStartDuration).valueOf() > currentObj.valueOf();

                        if (isCurrentDateValid) handlePriceData("prev");
                    }
                }}
            >
                PREV
            </CustomButton>
            <CustomText>
                {newDate.year}년 {newDate.month}월 {newDate.days}일 ({newDate.weekday})
            </CustomText>
            <CustomButton size="medium" onClick={() => handlePriceData("next")}>
                NEXT
            </CustomButton>
        </Center>
    );
};
